<template>
  <b-modal
    size="lg"
    id="user-already-exist-modal"
    ref="modal"
    :title="$t('user.already.exists')"
    @hidden="resetModal"
    @ok="handleOk"
    :ok-title="$t('Validate')"
    :cancel-title="$t('Cancel')"
    cancel-variant="danger">

    <div class="row">
    <div class="col-md-6">
      <div class="d-flex flex-column mb-3">
        <div class="bold-text"> {{ $t('user.Firstname') }}</div>
        <div> {{ this.user.firstname }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="d-flex flex-column mb-3">
        <div class="bold-text"> {{ $t('user.Lastname') }}</div>
        <div> {{ this.user.lastname }}</div>
      </div>
    </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="d-flex flex-column mb-3">
          <div class="bold-text"> {{ $t('user.PhoneNumber') }}</div>
          <div> {{ this.user.phoneNumber }}</div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="d-flex flex-column mb-3">
          <div class="bold-text"> {{ $t('user.Username') }}</div>
          <div> {{ this.user.username }}</div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {bus} from "../../main";


export default {

  name: 'UserAlreadyExist',

  data() {
    return {
      user:{},
    }
  },
  created() {
    bus.$on('toggleModal', (user) => {
      this.user = user;
      if(this.user.firstname){
        this.$nextTick(() => {
          this.$bvModal.show('user-already-exist-modal');
        });
      }
    });
  },

  beforeDestroy() {
    bus.$off('toggleModal',(user) =>{
      this.user={};
    })
  },

  methods: {


    resetModal () {
      this.user = {}
    },

    handleOk (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleSubmit()
    },

    handleSubmit () {
      bus.$emit('handleSubmit')
      this.resetModal()
      this.hideModal()
    },

    hideModal () {
      this.$bvModal.hide('user-already-exist-modal')
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserAlreadyExist.vue